import React, { useRef, useState } from "react";
import "./cardEvent.scss";

import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import CustomDialog from "../../components/customDialog/CustomDialog";

import { t } from "i18next";
import {
  deleteEventWS,
  deleteLikeWS,
  duplicateEventWS,
  postLikeWS,
  terminatedEventWS,
} from "./api/cardEventAPI";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { gestioneSnackbar } from "../../utils/common";

const CardEvent = ({
  id,
  title,
  associationName,
  eventAddress,
  photo,
  startDatetime,
  isLike,
  numberLike,
  viewLike = true,
  idAssociation,
  history = false,
  refreshContent,
}) => {
  const navigate = useNavigate();
  const dropdownRef = useRef();
  const [like, setLike] = useState(isLike);

  const handleCardClick = (e) => {
    // Se il click proviene dal Dropdown, non navigare
    if (dropdownRef.current && dropdownRef.current.contains(e.target)) {
      return;
    }

    // Naviga solo se il click NON proviene dal Dropdown
    navigate("/event/" + id);
  };

  const handleClickLike = (id) => {
    if (!like) {
      postLikeWS({ id_event: id })
        .then((res) => {
          setLike(!like);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      deleteLikeWS({ id_event: id })
        .then((res) => {
          setLike(!like);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div className="card-event-box" onClick={handleCardClick}>
      {history ? (
        <div className="banner-terminated-event">
          {t("common.terminated_event").toUpperCase()}
        </div>
      ) : null}
      {idAssociation ? (
        <div className="menu-icon" ref={dropdownRef}>
          <Dropdown>
            <Dropdown.Toggle
              as="button"
              variant="light"
              id="dropdown-menu"
              className=" bg-transparent border-0 p-0"
            >
              <MoreVertOutlinedIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ zIndex: 2 }}>
              <Dropdown.Item
                onClick={() =>
                  navigate(
                    "/dashboard/" +
                      idAssociation +
                      "/create-event/?id_event=" +
                      id
                  )
                }
              >
                {t("list_event.option.edit")}
              </Dropdown.Item>

              <CustomDialog
                title={t("list_event.modal_duplicate.title")}
                body={t("list_event.modal_duplicate.body")}
                textClose={t("common.cancel")}
                textCallToAction={t("common.confirm")}
                trigger={
                  <Dropdown.Item>
                    {t("list_event.option.duplicate")}
                  </Dropdown.Item>
                }
                callback={() => {
                  duplicateEventWS({ id_event: id })
                    .then((res) => {
                      refreshContent();
                      gestioneSnackbar(true, res.message, "success");
                    })
                    .catch((err) => gestioneSnackbar(true, err.title, "error"));
                }}
              />

              <CustomDialog
                title={t("list_event.modal_delete.title")}
                body={t("list_event.modal_delete.body")}
                textClose={t("common.cancel")}
                textCallToAction={t("common.confirm")}
                trigger={
                  <Dropdown.Item>{t("list_event.option.delete")}</Dropdown.Item>
                }
                callback={() => {
                  deleteEventWS({ id_event: id })
                    .then((res) => {
                      refreshContent();
                      gestioneSnackbar(true, res.message, "success");
                    })
                    .catch((err) => gestioneSnackbar(true, err.title, "error"));
                }}
              />

              <CustomDialog
                title={t("list_event.modal_terminated.title")}
                body={t("list_event.modal_terminated.body")}
                textClose={t("common.cancel")}
                textCallToAction={t("common.confirm")}
                trigger={
                  <Dropdown.Item>
                    {t("list_event.option.terminated")}
                  </Dropdown.Item>
                }
                callback={() => {
                  terminatedEventWS({ id_event: id })
                    .then((res) => {
                      refreshContent();
                      gestioneSnackbar(true, res.message, "success");
                    })
                    .catch((err) =>
                      gestioneSnackbar(true, err.message, "error")
                    );
                }}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ) : null}

      <div className="card-event-img">
        <img
          src={
            photo?.image
              ? "data:" + photo.image_type + ";base64," + photo.image
              : "/no_img.png"
          }
          alt="1"
        />
      </div>
      <div className="card-event-content">
        <div className="title">{title}</div>

        <div className="association-name">{associationName}</div>
        <div className="address-event">{eventAddress}</div>

        <div className="datetime-event">{startDatetime}</div>

        {viewLike ? (
          <div
            className="like-container"
            onClick={(e) => {
              e.stopPropagation();
              handleClickLike(id);
            }}
          >
            <div>{like ? <FavoriteIcon /> : <FavoriteBorderIcon />}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CardEvent;
